import React, { useContext, useState } from 'react';
import { useAsync } from 'react-commons';
import { Button, Container, Col, Row } from 'react-bootstrap';
import Loading from 'react-loading';
import BasicUserConfigModal from './BasicUserConfigModal';
import { getUserInformation } from '../../util/AuthUtils';
import UserContext from '../../context/UserContext';
import LocalizationContext from '../../context/LocalizationContext';

/**
 * Creates the default user config page after user is authenticated in application
 * Displays name, username, regional office, preferred language, and timezone
 */

const BasicUserConfig = () => {
  const userInfo = useContext(UserContext);
  const localizedStrings = useContext(LocalizationContext);
  if (userInfo) {
    const defaultState = {
      locale: '',
      timezone: ''
    };
    const {
      value,
      loading,
      refresh
    } = useAsync(() => getUserInformation(), defaultState);
    const [show, setShow] = useState(false);
    if (loading || value === null) {
      return /*#__PURE__*/React.createElement(Loading, {
        "data-testid": "loading-user-config"
      });
    }
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
      className: "mt-6"
    }, /*#__PURE__*/React.createElement(Col, {
      md: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "float-right"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      onClick: () => setShow(true)
    }, localizedStrings.hyrule.userProfile.edit), /*#__PURE__*/React.createElement(BasicUserConfigModal, {
      userInfo: userInfo,
      title: localizedStrings.hyrule.userProfile.edit,
      refresh: refresh,
      show: show,
      onHide: () => setShow(false)
    })), /*#__PURE__*/React.createElement("h2", null, localizedStrings.hyrule.userProfile.title), /*#__PURE__*/React.createElement("h2", {
      className: "border-bottom mt-2"
    }, " "))), /*#__PURE__*/React.createElement(Row, {
      className: "mt-3 ml-1"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 5,
      className: "font-weight-bold"
    }, localizedStrings.hyrule.userProfile.name), /*#__PURE__*/React.createElement(Col, {
      sm: 7
    }, userInfo.firstName, " ", userInfo.lastName)), /*#__PURE__*/React.createElement(Row, {
      className: "mt-3 ml-1"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 5,
      className: "font-weight-bold"
    }, localizedStrings.hyrule.userProfile.username), /*#__PURE__*/React.createElement(Col, {
      sm: 7
    }, userInfo.userId)), /*#__PURE__*/React.createElement(Row, {
      className: "mt-3 ml-1"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 5,
      className: "font-weight-bold"
    }, localizedStrings.hyrule.userProfile.regionalOffice), /*#__PURE__*/React.createElement(Col, {
      sm: 7
    }, userInfo.regionalOffice)), /*#__PURE__*/React.createElement(Row, {
      className: "mt-3 ml-1"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 5,
      className: "font-weight-bold"
    }, localizedStrings.hyrule.userProfile.preferredLanguage), /*#__PURE__*/React.createElement(Col, {
      sm: 7
    }, userInfo.userSettings.baseSettings.locale)), /*#__PURE__*/React.createElement(Row, {
      className: "mt-3 ml-1"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 5,
      className: "font-weight-bold"
    }, localizedStrings.hyrule.userProfile.timezone), /*#__PURE__*/React.createElement(Col, {
      sm: 7
    }, userInfo.userSettings.baseSettings.timezone)));
  }
  return null;
};
export default BasicUserConfig;